import CloseIcon from "../../../../../../assets/svg/close-icon";
import AddUserIcon from "../../../../../../assets/svg/add-user-icon";

interface CreateUserHeaderProps {
  handleCloseDrawer: () => void;
}

export const CreateUserHeader = ({
  handleCloseDrawer,
}: CreateUserHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <AddUserIcon className="w-6 h-6 text-verba-blue dark:text-verba-blue-dk" />
        <div className="flex flex-col">
          <span className="text-base text-heading-text dark:text-heading-text-dk">
            Create new user, one at a time!
          </span>
          <span className="text-xs text-dark-gray dark:text-dark-gray-dk">
            Add a new user to your VerbaFlo dashboard
          </span>
        </div>
      </div>
      <button
        className="w-[16px] h-[16px] bg-gray-100 dark:bg-gray-100-dk rounded-full flex flex-col items-center justify-center"
        aria-label="close create user modal"
        onClick={handleCloseDrawer}
      >
        <CloseIcon className="w-[6px] h-[6px] text-verba-indigo dark:text-verba-indigo-dk" />
      </button>
    </div>
  );
};
